export default {
  paper: {
    position: 'relative',
    zIndex: 10000,
    background: '#fff',
    marginTop: 8,
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.15)',
  },
  arrowPopper: {
    '&[data-popper-placement="bottom"] $arrowArrow': {
      top: 0,
      left: 0,
      marginTop: '1em',
    },
    '&[data-popper-placement="top"] $arrowArrow': {
      bottom: '-1.5em',
      left: 0,
    },
    '&[data-popper-placement="right"] $arrowArrow': {
      left: 0,
      marginLeft: '1em',
    },
    '&[data-popper-placement="left"] $arrowArrow': {
      right: 0,
      marginRight: '1em',
    },
  },
  arrowArrow: {
    position: 'absolute',
    fontSize: 7,
    zIndex: 10000,
    left: '50%!important',
    width: '1.5em',
    height: '1.5em',
    backgroundColor: '#FFF',
    borderTop: '1px solid #FFF',
    borderLeft: '1px solid #FFF',
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.15)',
    transform: 'translateX(-50%) translateY(-50%) rotate(45deg)!important',
  },
  roundArrow: {
    position: 'absolute',
    zIndex: 10000,
    width: '20px',
    height: '20px',
    backgroundColor: 'var(--color-white)',
    left: '50% !important',
    transform: 'translate(-50%, -50%) rotate(45deg)!important',
    borderRadius: '8px 0 0',
  },
};
